import { Reveal } from "./Reveal";
import { Eyebrow } from "./Shared";

const notes = [
  {
    num: "01",
    title: "Design for the person holding the phone.",
    body: "Most financial products are designed for the institution. u-topia is the opposite bet: if it is not obvious at the edge of the network, it is not finished.",
  },
  {
    num: "02",
    title: "Teach before you extract.",
    body: "U-Academy exists because access without literacy is just a prettier trap. A community that understands the rails will protect the rails.",
  },
  {
    num: "03",
    title: "Show up.",
    body: "Twenty-two cities. Small rooms. Names learned. He treats leadership as a physical act: presence, cadence, a written record. Silence is not mystique. It is a defect.",
  },
];

export default function Notes() {
  return (
    <section id="notes" data-testid="notes-section" className="scroll-mt-20 bg-navy py-24 lg:py-32">
      <div className="mx-auto w-full max-w-[1200px] px-6">
        <Reveal>
          <Eyebrow>How he thinks</Eyebrow>
          <h2 className="mt-4 text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl lg:text-5xl">
            Three ideas he <span className="text-brand-orange">will not negotiate.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {notes.map((n, i) => (
            <Reveal key={n.num} delay={i * 0.1}>
              <article
                data-testid={`note-card-${n.num}`}
                className="flex h-full flex-col rounded-2xl border border-white/10 bg-navy-lift p-8"
              >
                <span className="text-sm font-semibold tracking-[0.2em] text-brand-orange">
                  {n.num}
                </span>
                <h3 className="mt-5 text-xl font-semibold tracking-tight text-white">
                  {n.title}
                </h3>
                <p className="mt-4 text-[15px] leading-relaxed text-white/70">{n.body}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
